import { useState, useEffect } from 'react';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { RouteLoader } from '@/shared/components';
import { AppProviders } from './AppProviders';
import { AppRouter } from './AppRouter';

const App = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, 1500);

    const hideTimer = setTimeout(() => {
      setShowLoader(false);
    }, 2000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <>
      {showLoader && <RouteLoader isVisible={!isFadingOut} />}
      <ErrorBoundary>
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </ErrorBoundary>
    </>
  );
};

export default App;
